// Single source of Redux truth for the user's active project selection.
// See docs/product/bugs/project-access-scoping-trd.md Section 2.4/R1 for
// the original design, and
// docs/product/bugs/connect-cta-new-tab-project-leak/trd.md Section 2.3/
// Section 3, R8 for why this is now pure in-memory state.
//
// This is the only file that owns the shape of `currentProject` state.
// No module other than currentProjectService.js may import this slice's
// actions or reach into the `currentProject` branch of the store directly
// (enforced by convention, not by tooling) — see currentProjectService.js.
//
// This slice no longer reads or writes sessionStorage at all: the URL's
// :projectId path segment (read by ProjectRouteGuard on every
// project-scoped route) is now the source of truth for the general case
// -- a brand-new browser tab gets its own URL carrying its own project
// ID, independent of whatever any local/session storage in that fresh
// browsing context happens to hold, which is what closes the
// new-tab-project-leak bug this mechanism used to be vulnerable to. The
// one remaining case that still needs a storage-backed signal (the Shopify
// OAuth full-page redirect round trip) is handled narrowly by
// utils/shopifyGrantFlowProject.js instead -- not by this slice.
import { createSlice } from '@reduxjs/toolkit';

const currentProjectSlice = createSlice({
  name: 'currentProject',
  initialState: { value: null },
  reducers: {
    set: (state, action) => {
      state.value = action.payload;
    },
    clear: (state) => {
      state.value = null;
    },
  },
});

export const { set, clear } = currentProjectSlice.actions;
export default currentProjectSlice.reducer;
